<script setup lang="ts">
import { computed } from "vue";
import IconAtom from "./IconAtom.vue";

const props = defineProps<{
  modelValue?: string;
  placeholder?: string;
  iconLeading?: string;
  disabled?: boolean;
  id?: string;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
}>();

const value = computed({
  get: () => props.modelValue || "",
  set: (val) => emit("update:modelValue", val),
});
</script>

<template>
  <div class="input-atom">
    <IconAtom
      v-if="iconLeading"
      :name="iconLeading as any"
      :size="24"
      color="#8896AA"
      class="input-atom__icon"
    />
    <input
      :id="id"
      v-model="value"
      type="text"
      :placeholder="placeholder"
      :disabled="disabled"
      class="input-atom__field"
      :class="{ 'input-atom__field--with-icon': iconLeading }"
    />
  </div>
</template>

<style scoped lang="scss">
@use "@/assets/styles/design-tokens" as *;

.input-atom {
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 100%;

  &__icon {
    position: absolute;
    left: 12px;
    pointer-events: none;
    z-index: 1;
  }

  &__field {
    width: 100%;
    height: 40px;
    padding: 8px 10px;
    border: 1px solid #eaecf1;
    border-radius: 12px;
    background-color: #ffffff;
    font-family: "Satoshi", sans-serif;
    font-size: $txt-small-size;
    font-weight: 500;
    line-height: $txt-small-line-height;
    color: #121826;
    letter-spacing: 0.3px;
    outline: none;
    transition: border-color 0.2s ease;

    &::placeholder {
      color: #8896aa;
    }

    &:focus {
      border-color: #5e58ee;
    }

    &:disabled {
      background-color: #f4f5f8;
      color: #8896aa;
      cursor: not-allowed;
    }

    &--with-icon {
      padding-left: 44px;
    }
  }
}
</style>
